import { render, staticRenderFns } from "./RescheduledTicketsList.vue?vue&type=template&id=af0a8716"
import script from "./RescheduledTicketsList.vue?vue&type=script&lang=js"
export * from "./RescheduledTicketsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports